module.exports = __webpack_public_path__ + "static/media/learning-progress-icon.50213bf3.svg";